import carrierProductSlice from './reducer'

export default carrierProductSlice.reducer
